import React from 'react';
import { useTranslation } from 'context/LanguageContext';

const SizeSelector = ({ 
  sizes, 
  selectedSize,
  onSizeSelect
}) => {
  const hasSizes = sizes && Array.isArray(sizes) && sizes.length > 0;
  const { t } = useTranslation();

  if (!hasSizes) return null;

  return (
    <div className="mb-6">
      <label className="block text-sm font-semibold text-gray-900 mb-3">
        {t("selectSize")} <span className="text-red-500">*</span>
      </label>
      
      {/* Size Grid */}
      <div className="grid grid-cols-4 gap-3">
        {sizes.map((size, index) => (
          <button
            key={index}
            onClick={() => onSizeSelect(size)}
            className={`
              py-3 px-4 rounded-lg border-2 font-medium transition-all duration-200
              ${selectedSize === size
                ? 'border-blue-500 bg-blue-50 text-blue-700'
                : 'border-gray-200 bg-white text-gray-700 hover:border-gray-300 hover:bg-gray-50'
              }
            `}
          >
            {size}
          </button>
        ))}
      </div>

      {/* Selected size indicator */}
      {selectedSize && (
        <div className="mt-4 p-3 bg-blue-50 rounded-lg border border-blue-200">
          <p className="text-sm text-blue-700">
            Selected size: <span className="font-semibold">{selectedSize}</span>
          </p>
        </div>
      )}
    </div>
  );
};

export default SizeSelector;
